<div class="ais-RefinementList" *ngIf="state?.value?.onFacetValue?.count > 0">
  <div>
    <!-- this div is here to simulate the ng-ais-header container -->
    <button
      class="ais-RefinementList-header ais-header"
      [ngClass]="{'ais-RefinementList-header--closed': !showRefinementBody}"
      (click)="toggleShowBody()"
    >
      <span *ngIf="options.label === 'DELIVERY_OPTS.EXPRESS'" i18n="@@DELIVERY_OPTS.EXPRESS">Express Delivery</span>
      <span *ngIf="options.label === 'CATALOG.FILTERS.DS'" i18n="@@CATALOG.FILTERS.DS">Direct Shipping</span>
    </button>
  </div>
  <div class="ais-RefinementList-body ais-body" [ngStyle]="{display: showRefinementBody ? 'block' : 'none'}">
    <ul class="ais-RefinementList-list">
      <li *ngIf="state && state.value && state.value.onFacetValue">
        <input
          id="toggle__{{ state.value.name + '_on' }}"
          class="filters_checkbox_input"
          type="checkbox"
          (change)="refineToggle($event, state.value)"
          [checked]="state.value.onFacetValue.isRefined ? 'checked' : null"
        />
        <label
          *ngIf="state.value.onFacetValue.name === 'stock_on'"
          for="toggle__{{ state.value?.name + '_on' }}"
          class="filters_checkbox_label"
        >
          <a *ngIf="seoUrl; else stockLabel" [href]="seoUrl">
            <ng-template *ngTemplateOutlet="stockLabel"></ng-template>
          </a>
          <ng-template #stockLabel i18n="@@CATALOG.FILTERS.STOCK_24">
            Items shipped within 24 hours
          </ng-template>
          <span class="filters_checkbox_label_count">({{ state.value.onFacetValue.count }})</span>
        </label>
        <label
          *ngIf="state.value.onFacetValue.name === 'dsEligibleCountries_on'"
          for="toggle__{{ state.value?.name + '_on' }}"
          class="filters_checkbox_label"
        >
          <a *ngIf="seoUrl; else dsLabel" [href]="seoUrl">
            <ng-template *ngTemplateOutlet="dsLabel"></ng-template>
          </a>
          <ng-template #dsLabel i18n="@@CATALOG.FILTERS.DS_LABEL">
            Items eligible for Direct Shipping
          </ng-template>
          <span class="filters_checkbox_label_count">({{ state.value.onFacetValue.count }})</span>
        </label>
      </li>
    </ul>
  </div>
</div>
